import { API_URL } from "../../../utils/auth";

const PUBLIC_MENU_URL = `${API_URL}/menu/public/`;

export async function fetchPublicMenu({ signal } = {}) {
  const response = await fetch(PUBLIC_MENU_URL, {
    headers: { Accept: "application/json" },
    signal,
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(
      data?.error?.message ||
        data?.detail ||
        "The menu could not be loaded.",
    );
  }

  return Array.isArray(data) ? data : [];
}
